import { BLACK_d, BLACK_e, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 25rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 15rem;
  }
`;

export const TextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & > div {
    &:nth-child(1) {
      font-weight: 700;
      font-size: 5.2rem;
      line-height: 9.2rem;
    }
    &:nth-child(2) {
      font-weight: 300;
      font-size: 2.2rem;
      line-height: 3.8rem;
      color: ${BLACK_d};
      display: flex;
      flex-direction: column;
      width: 90rem;
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    align-items: baseline;
    text-align: left;
    & > div {
      &:nth-child(1) {
        font-weight: 700;
        font-size: 2.8rem;
        line-height: 5rem;
      }
      &:nth-child(2) {
        font-weight: 300;
        font-size: 1.8rem;
        line-height: 3.2rem;
        display: block;
        width: 100%;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 15rem;
  width: 150rem;
  & > div:nth-child(1) {
    margin-top: 8rem;
    & > img {
      width: 40rem;
      height: 40rem;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column-reverse;
    position: relative;
    overflow-x: hidden;
    width: 100%;
    & > div:nth-child(1) {
      & > img {
        position: absolute;
        bottom: -3rem;
        left: 10rem;
        width: 30rem;
        height: 30rem;
      }
    }
  }
`;

export const ContentBox = styled.div`
  display: flex;
  margin-top: 10rem;
  flex-wrap: wrap;
  gap: 6rem 14rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 6rem;
    flex-direction: column;
  }
`;

export const TextBox2 = styled.div`
  min-width: 21.6rem;
  & > div {
    &:nth-child(1) {
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 2.4rem;
      color: ${MAIN_GREEN};
    }
    &:nth-child(2) {
      margin-top: 1rem;
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 4.2rem;
    }
    &:nth-child(3) {
      margin-top: 1rem;
      font-weight: 300;
      font-size: 1.8rem;
      line-height: 3.2rem;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div {
      &:nth-child(1) {
        font-weight: 300;
        font-size: 1.4rem;
        line-height: 2.4rem;
        color: ${MAIN_GREEN};
      }
      &:nth-child(2) {
        margin-top: 1rem;
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3.8rem;
      }
      &:nth-child(3) {
        margin-top: 1rem;
        font-weight: 300;
        font-size: 1.8rem;
        line-height: 3.2rem;
      }
    }
  }
`;

export const List = styled.div`
  display: flex;
  margin-top: 1rem;
  flex-direction: column;
  min-width: 27.5rem;
  & > div {
    display: flex;
    & > img {
      width: 0.4rem;
      height: 0.4rem;
      margin-top: 1.4rem;
      margin-right: 1rem;
    }
    & > div {
      font-weight: 300;
      font-size: 1.8rem;
      line-height: 3.2rem;
      color: ${BLACK_e};
      display: flex;
      flex-direction: column;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div {
      & > div {
        font-weight: 300;
        font-size: 1.8rem;
        line-height: 3.2rem;
        color: ${BLACK_e};
        display: flex;
        flex-direction: column;
      }
    }
  }
`;
